import { Search } from 'lucide-react';
import { useEffect, useState } from 'react';

import { DateRangePicker } from '@/components/DateRangePicker';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import type { ReportFilters as Filters } from '@/hooks/useReports';
import { track } from '@/lib/mixpanel';

type Props = {
  filters: Filters;
  onFilterChange: (filters: Filters) => void;
};

export function ReportFilters({ filters, onFilterChange }: Props) {
  const [symbolInput, setSymbolInput] = useState(filters.symbol ?? '');
  useEffect(() => {
    setSymbolInput(filters.symbol ?? '');
  }, [filters.symbol]);

  const handleSymbolSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const symbol = symbolInput.trim().toUpperCase() || undefined;
    track('Reports_SymbolSearched', { symbol });
    onFilterChange({
      ...filters,
      symbol,
    });
  };

  return (
    <div className="mb-6">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex flex-wrap items-center gap-2">
        <form
          onSubmit={handleSymbolSubmit}
          className="flex items-center gap-2">
          <div className="relative w-full sm:w-auto">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-neutral-400" />
            <Input
              type="text"
              placeholder="Caută simbol (ex: TLV, SNN)"
              value={symbolInput}
              onChange={(e) => setSymbolInput(e.target.value)}
              className="pl-9 bg-white sm:w-64"
            />
          </div>
          <Button type="submit" variant="outline" size="default">
            Caută
          </Button>
        </form>
        </div>

        <DateRangePicker
          dateRange={filters.dateRange}
          onChange={(dateRange) =>
            onFilterChange({
              ...filters,
              dateRange,
            })
          }
          onClear={() =>
            onFilterChange({
              ...filters,
              dateRange: undefined,
            })
          }
        />
      </div>
    </div>
  );
}
